/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_File_Name_TitleInputs */

const en_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Name`)
};

const fr_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de fichier`)
};

const de_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiname`)
};

const it_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del file`)
};

const ru_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя файла`)
};

const es_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del archivo`)
};

const zh_cn2_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件名`)
};

const ja_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル名`)
};

const hi_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल नाम`)
};

const pt_pt2_explorer_display_file_name_title = /** @type {(inputs: Explorer_Display_File_Name_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do arquivo`)
};

/**
* | output |
* | --- |
* | "File Name" |
*
* @param {Explorer_Display_File_Name_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_file_name_title = /** @type {((inputs?: Explorer_Display_File_Name_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_File_Name_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_file_name_title(inputs)
	if (locale === "de") return de_explorer_display_file_name_title(inputs)
	if (locale === "it") return it_explorer_display_file_name_title(inputs)
	if (locale === "ru") return ru_explorer_display_file_name_title(inputs)
	if (locale === "es") return es_explorer_display_file_name_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_file_name_title(inputs)
	if (locale === "ja") return ja_explorer_display_file_name_title(inputs)
	if (locale === "hi") return hi_explorer_display_file_name_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_file_name_title(inputs)
	return en_explorer_display_file_name_title(inputs)
});